import genericApi from './genericApi';
import { baseUrl } from './baseUrl';
import ApiResponse from '../models/ApiResponse';
import Attachment from '../models/Attachment';
import UnrecognizedDocs from '../models/AutoDocRecognitionResponse';

const attachmentsRequestHandler = {
  uploadFile: (awbCode: string, awbNumber: string, version: number, type: string, data: FormData, rfs?: boolean): Promise<ApiResponse<boolean>> => {
    let queryParams = `?type=${type}`;
    if (rfs) queryParams += '&rfs=true';
    return genericApi.postFile(`awb/${awbCode}/${awbNumber}/${version}/attachment${queryParams}`, data);
  },

  loadAttachments: (awbCode: string, awbNumber: string, version: number, orderNumber?: string, rfs?: boolean): Promise<ApiResponse<Array<Attachment>>> => {
    let url = `awb/${awbCode}/${awbNumber}/${version}/attachment?`;
    if(rfs) {
      url += `rfs=${rfs}&`
    }
    if(orderNumber) {
      url += `order_number=${orderNumber}`
    }
    return genericApi.get(url);
  },

  loadOrderAttachments: (orderId: number): Promise<ApiResponse<Array<Attachment>>> => {
    return genericApi.get(`pickup_order/${orderId}/attachment`);
  },

  uploadOfflineOrderFile: (orderId: number, type: string, data: FormData, rfs?: boolean): Promise<ApiResponse<boolean>> => {
    let queryParams = `?type=${type}`;
    if (rfs) queryParams += '&rfs=true';
    return genericApi.postFile(`offline_order/${orderId}/attachment${queryParams}`, data);
  },

  uploadOrderFile: (orderId: number, type: string, data: FormData): Promise<ApiResponse<boolean>> => {
    return genericApi.postFile(`pickup_order/${orderId}/attachment?type=${type}`, data);
  },

  loadOfflineAttachments: (orderId: number, rfs?: boolean): Promise<ApiResponse<Array<Attachment>>> => {
    let url = `offline_order/${orderId}/attachment`;
    if(rfs) {
      url += `?rfs=${rfs}`;
    }
    return genericApi.get(url);
  },

  constructAttachmentUrl: (key:string):string => {
    return `${baseUrl}attachment/${key}`;
  },

  constructOfflineAttachmentUrl: (key:string):string => {
    return `${baseUrl}offline_order/attachment/${key}`;
  },

  deleteAttachment: (key:string):Promise<ApiResponse<boolean>> => {
    return genericApi.delete(`attachment/${key}`);
  },

  deleteOfflineAttachment: (key:string):Promise<ApiResponse<boolean>> => {
    return genericApi.delete(`offline_order/attachment/${key}`);
  },

  changeAttachmentAccessibility: (key:string, isPrivate: boolean, type: string):Promise<ApiResponse<boolean>> => {
    let accessibilityValue: string = 'public';

    if (isPrivate) {
      accessibilityValue = 'private';
    }

    return genericApi.put(`attachment/${key}/accessibility/${accessibilityValue}`, { type });
  },

  changeOrderAttachmentAccessibility: (key:string, isPrivate: boolean):Promise<ApiResponse<boolean>> => {
    let accessibilityValue: string = 'public';

    if (isPrivate) {
      accessibilityValue = 'private';
    }

    return genericApi.put(`offline_order/attachment/${key}/accessibility/${accessibilityValue}`);
  },

  loadUnrecognizedAttachments: () : Promise<ApiResponse<Array<UnrecognizedDocs>>> => {
    return genericApi.get(`unrecognized_documents`);
  },

  getUnrecognizedAttachementById: (id: string) : Promise<ApiResponse<UnrecognizedDocs>> => {
    return genericApi.get(`unrecognized_documents_by_id?id=${id}`);
  },

  constructUnrecognizedAttachmentUrl: (key:string):string => {
    return `${baseUrl}unrecognized_attachment?key=${key}`;
  },

  deleteUnrecognizedAttachment: (key:string):Promise<ApiResponse<boolean>> => {
    return genericApi.delete(`unrecognized_attachment?key=${key}`);
  },

  addAttachmentForAwbOrOrder: (awbId: number | null, orderId: number | null, attachment_key: string, from_email: string, mail_received_dt: string, message_id: string, source_email: string, attachmentType: string) : Promise<ApiResponse<boolean>> => {
    return genericApi.post('add_attachment_to_awb_or_order', {awbId, orderId, attachment_key, from_email, mail_received_dt, message_id, source_email, attachmentType});
  },

  checkOfflineRfsOrderExists: (airlineCode: string, rfsNumber: string, scheduleDate: string): Promise<ApiResponse<any>> => {
    return genericApi.get(`offlinerfs_order_exists/${rfsNumber}/${airlineCode}?schedule_date=${scheduleDate}`);
  },

  addUnrecognizedAttachmentForOfflineRfs: (rfsId: number, attachment_key: string, from_email: string, mail_received_dt: string, message_id: string, source_email: string, attachmentType: string) : Promise<ApiResponse<boolean>> => {
    return genericApi.post(`offlinerfs_add_unrecognized_doc`, {rfsId, attachment_key, from_email, mail_received_dt, message_id, source_email, attachmentType});
  }
};

export default attachmentsRequestHandler;
